import {AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {IDriverTreeItem} from '@atl/admin/drivers/interfaces';
import {TypesUtils} from "@atl/shared/utils";
import {LtaTreeComponent} from "@atl/modules/tree/tree.component";
import {GetChildrenFn, ILtaNodeData, ILtaTreeOptions} from "@atl/modules/tree/interfaces/tree.interface";
import {ObjectsService} from '@app/@atl/administration/objects/services';

@UntilDestroy()
@Component({
    selector: 'lta-driver-elements-dialog',
    templateUrl: 'driver-elements-dialog.component.html',
    styleUrls: ['driver-elements-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ObjectsService]
})
export class DriverElementsDialogComponent implements AfterViewInit {
    @Output() onSave = new EventEmitter<IDriverTreeItem>();
    @Output() onCancel = new EventEmitter<void>();
    @Input() withSelect: boolean;
    @ViewChild('tree') public tree: LtaTreeComponent;
    public selectedDriverTreeItem: IDriverTreeItem;
    @Input() driverTreeItems: IDriverTreeItem[]
    public treeOptions: ILtaTreeOptions

    constructor() {
    }

    @Input() set loadChildrenFn(fn: GetChildrenFn) {
        this.treeOptions = {
            getChildrenFn: fn,
            selectAction: this.selectAction.bind(this)
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.tree.nodes = this.driverTreeItems.map(i => TypesUtils.driverTreeItemToNodeData(i))
        })
    }

    private selectAction(data: ILtaNodeData) {
        if (data.id === this.selectedDriverTreeItem?.object_id) {
            this.selectedDriverTreeItem = null
            this.tree.resetActive()
        } else {
            this.selectedDriverTreeItem = data.id ? this.tree.getNodeById(data.id).data.item : null
            if (this.selectedDriverTreeItem) {
                this.tree.setActive(data.id)
                this.tree.resetFocus()
            }
        }
    }
}
